﻿

//$(document).ready(function () {
    if ($(".mortgage-rate-widget").length > 0) {
        $.getScript("https://code.highcharts.com/stock/highstock.js", function () {
            $.getScript("https://code.highcharts.com/stock/modules/exporting.js", function () {
                $.getScript("https://code.highcharts.com/stock/modules/export-data.js", function () {
                    $.getScript("https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.13.5/xlsx.full.min.js", function () {
                        $.getScript("https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.18.1/moment.min.js", function () {
                            $.getScript("https://cdnjs.cloudflare.com/ajax/libs/jquery-date-range-picker/0.16.0/jquery.daterangepicker.min.js", function () {
                                DrawChart();
                            });
                        });
                    });
                });
            });
        });
    }
//});



function DrawChart() {
    $('head').append($('<link rel="stylesheet" type="text/css" />').attr('href', 'https://cdnjs.cloudflare.com/ajax/libs/jquery-date-range-picker/0.16.0/daterangepicker.min.css'));
    var colors = [
'#f58220', '#538f94', '#789441'
    ];

    var ranges = [1, 3, 5, 10, 'A'];
    var popupDefaults = "channelmode=no,directories=no,fullscreen=no,location=no,status=no,toolbar=no,modal=yes,alwaysRaised=yes,resizable=yes";
    var MortgageChart = window.MortgageRateChart = function (el) {

        this.el = el;
        this.$el = $(el);
        this.$el.data('MortgageChart', this);
        this.dataDir = (this.$el.data('data-dir') || '/data').replace(/\/$/, '');
        this.spreadsheetUrl = (this.$el.data('spreadsheet') || false);
        this.loaded = 0;
        this.rates = [30, 15];
        this.series = [];
        this.turboThreshold = 100;
        this.init();
    };

    // add PlotBandSeries

    Highcharts.seriesType('plotband', 'column', {
        lineWidth: 0,
        threshold: null
    }, {
        /*= if (build.classic) { =*/
        // mapping between SVG attributes and the corresponding options
        pointAttrToOptions: {
            fill: 'color',
            stroke: 'lineColor',
            'stroke-width': 'lineWidth'
        },
        /*= } =*/
        animate: function () { },

        translate: function () {
            var series = this,
                xAxis = series.xAxis,
                yAxis = series.yAxis;

            Highcharts.Series.prototype.translate.apply(series);

            Highcharts.each(series.points, function (point) {
                var onXAxis = point.onXAxis,
                    ownAxis = onXAxis ? xAxis : yAxis,
                    otherAxis = onXAxis ? yAxis : xAxis,
                    from = ownAxis.toPixels(point.from, true),
                    to = ownAxis.toPixels(point.to, true),
                    start = Math.min(from, to),
                    width = Math.abs(to - from);

                point.plotY = 1; // lure ColumnSeries.drawPoints
                point.shapeType = 'rect';
                point.shapeArgs = ownAxis.horiz ? {
                    x: start,
                    y: 0,
                    width: width,
                    height: otherAxis.len
                } : {
                    x: 0,
                    y: start,
                    width: otherAxis.len,
                    height: width
                };
            });
        }


    });


    var ns = "mortgage-rate-widget";

    $.extend(MortgageChart.prototype, {

        init: function () {
            //this.$title = $('<h4 class="' + ns + '__title" />').html(
            //    'Primary Mortgage Market Survey<sup>Â®</sup>'
            //).appendTo(this.$el);
          
            this.$chartModal = $('<div class="modal fade" id="chartModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" />').appendTo(this.$el);
            this.$rates = $('<div class="' + ns + '__rates row mt-3" />').appendTo(this.$el);
            
           
            this.$chartDialog = $(['<div class="modal-dialog" role="document"></div>'].join("")).appendTo(this.$chartModal);

           
            this.$dialog = $('<div class="modal-content px-5 pb-5 pt-0" />').appendTo(this.$chartDialog);
            this.$dialogHeader = $('<div class="' + ns + '__chartmodal-header modal-header px-0 py-0"><img class="img" src="/specs/releasedAssets/img/embrace-logo-orange.png" /><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button></div>').appendTo(this.$dialog);
           
            this.$chartHeading = $('<div class="' + ns + '__chart-heading" />').appendTo(this.$dialog);
            this.$chart = $('<div class="' + ns + '__chart" />').appendTo(this.$dialog);
            this.turboThreshold = 1000;

            if (this.spreadsheetUrl) {
                this.load(this.spreadsheetUrl, $.proxy(this.loadWorkbook, this));
            }


            $(window).on('resize', $.proxy(this.onResize, this));
            this.onResize();

            //this.$el.on('click', '[data-chart-action]', $.proxy( this.onChartAction, this) );
        },
        load: function (url, callback) {

            if (!callback) callback = function () { };

            var xhr = new XMLHttpRequest();

            xhr.open("GET", url, true);
            if (typeof Uint8Array !== 'undefined') {
                xhr.responseType = "arraybuffer";
                xhr.onload = $.proxy(function () {
                    var arraybuffer = xhr.response;

                    /* convert data to binary string */
                    var data = new Uint8Array(arraybuffer);
                    var arr = [];
                    for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
                    var bstr = arr.join("");

                    /* Call XLSX */
                    var workbook = XLSX.read(bstr, { type: "binary" });
                    callback(workbook);
                }, this);
            }
            else {

                xhr.setRequestHeader('Accept-Charset', 'x-user-defined');
                xhr.onreadystatechange = $.proxy(function () {
                    if (xhr.readyState == 4 && xhr.status == 200) {
                        var ff = convertResponseBodyToText(xhr.responseBody);
                        var wb = XLSX.read(ff, { type: "binary" });
                        callback(wb);
                    }
                }, this);

            }
            xhr.send();
        },

        loadWorkbook: function (workbook) {

            var lastUpdate = 0;

            var series = [
                {
                    "column": "B",
                    "name": "30Y FRM",
                    "title": "30-Yr FRM",
                    "showInNavigator": true,
                    "data": []
                },
                {
                    "column": "D",
                    "name": "15Y FRM",
                    "title": "15-Yr FRM",
                    "data": []
                }
                //,
                //{
                //    "column": "F",
                //    "name": "5/1 ARM",
                //    "title": "5/1-Yr ARM",
                //    "data": []
                //}
            ];

            var tzOffset = new Date().getTimezoneOffset() * 60 * 1000;

            $.each(workbook.Sheets, function (k, v) {
                // lets start at row 8...
                var i;
                for (i = 8; !!v['A' + i]; i++) {
                    var date = new Date(Math.round((v['A' + i].v - 25569) * 86400 * 1000) + tzOffset).getTime();
                    if (!date) {
                        continue;
                    }
                    $.each(series, function (j, s) {
                        if (!v[s.column + i] || !v[s.column + i].w) {
                            return;
                        }

                        var val = v[s.column + i].w;

                        s.data.push({
                            x: date,
                            y: parseFloat(val),
                            date: new Date(date),
                            /*fees: v[String.fromCharCode(s.column.charCodeAt(0) + 1) + i].w*/
                        });

                    });

                }
            });

            $.each(series, function (i, s) {
                s.data = s.data.sort(function (a, b) {
                    return a.x - b.x;
                });

                lastUpdate = Math.max(s.data[s.data.length - 1].x, lastUpdate);

                this.turboThreshold = Math.max(this.turboThreshold, s.data.length);
                s.data[s.data.length - 1].dataLabels = {
                    enabled: true,
                    align: 'left',
                    x: 3,
                    verticalAlign: 'middle',
                    overflow: true,
                    useHTML: false,
                    crop: false,
                    allowOverlap: true,
                    style: {
                        'color': colors[i],
                        'fontSize': '16px',
                        'fontWeight': '400'
                    },
                    formatter: function () {
                        var isLast = false;
                        if (!this.series) return;
                        if (!this.series.visible) return;
                        if (this.series.chart.options.legend.enabled) return;
                        if (this.point.x === this.series.data[this.series.data.length - 1].x && this.point.y === this.series.data[this.series.data.length - 1].y) isLast = true;
                        return isLast ? this.y + '%' : '';
                    }
                };

            });

            this.series = series;

            this.lastUpdate = lastUpdate;
            this.createBlocks();
            //var MyObject = this;
            //MyObject.createChart();
            //MyObject.createRangePicker();
            //$(".mortgage-rate-widget__seeChart").click(function () {
                
               // MyObject.createChart();
                //MyObject.createRangePicker();
               // if (MyObject.$el.data('admin')) {
                   //  MyObject.createAdminButtons();
            //}
            //});
            //this.createChart();
            //this.createRangePicker();
           
        },

        createBlocks: function () {

            //$('<h5 class="' + ns + '__subheading">U.S. weekly averages ' +
            //  'as of ' + moment(this.lastUpdate).format('MM/DD/YYYY') + '</h5>')
            //    .insertBefore(this.$rates);

            //$('div class="' + ns + '__copyright"></div>')
            //    .insertBefore(this.$rates);
            $('<div class="row mt-5 mb-3"><div class="col-md-9 pl-3"><small>Copyright 2022, <a href="http://www.freddiemac.com/" target="_top">Freddie Mac</a>. Averages are for conforming mortgages with 20% down.</small></div><div class="col-md-3 text-right"><a class="' + ns + '__seeChart" data-toggle="modal" data-target="#chartModal">See Chart</a></div></div>')
                .insertAfter(this.$rates);
          
            // lets create the blocks
            var $rates = this.$rates;
            $.each(this.series, function (i, s) {
                // create a rate block
                var cur = s.data[s.data.length - 1].y;
                var weekDelta = Math.round(100 * (cur - s.data[s.data.length - 2].y)) / 100;
                var yearDelta = Math.round(100 * (cur - s.data[s.data.length - 53].y)) / 100;
                var weekDeltaMovement = weekDelta > 0 ? 'increase' : weekDelta < 0 ? 'decrease' : 'none';
                var yearDeltaMovement = yearDelta > 0 ? 'increase' : yearDelta < 0 ? 'decrease' : 'none';

                var $rate = $([
                    '<div class="' + ns + '__rate col-md-4 col-sm-4 col-xs-4 text-center">',
                        '<div class="' + ns + '__rate-title" style="color:' + colors[i] + '">',
                          '<h4 class="mt-0 mb-2">' + s.title + '</h4>',
                        '</div>',
                        '<div class="' + ns + '__rate-details">',
                            '<div class="' + ns + '__rate-value">',
                               '<h2 class="m-0">'+ cur + '%</h2>',
                            '</div>',
                            '<div class="' + ns + '__rate-deltas">',
                                '<div class="' + ns + '__rate-delta ' + ns + '__rate-delta--' + weekDeltaMovement + '">',
                                    Math.abs(weekDelta).toFixed(2),
                                    ' 1-Wk',
                                '</div>',
                                '<div class="' + ns + '__rate-delta ' + ns + '__rate-delta--' + yearDeltaMovement + '">',
                                    Math.abs(yearDelta).toFixed(2),
                                    ' 1-Yr',
                                '</div>',
                            '</div>',
                        '</div>',
                        //'<div class="' + ns + '__rate-fees mt-2"><strong>',
                        //    s.data[s.data.length - 1].fees,
                        //    ' Fees/Points',
                        //'</strong></div>',
                    '</div>'
                ].join("")).appendTo($rates);
            });
            //draw the chart
            var MyObject = this;
            MyObject.createChart();
            MyObject.createRangePicker();


        },


        createChart: function () {

            this.series.push({
                type: 'plotband',
                name: 'Recessions',
                zIndex: -1,
                borderWidth: 0,
                lineWidth: 0,
                color: 'rgba( 0, 0, 0, 0.08)',
                data: [{
                    from: Date.UTC(1973, 11),
                    to: Date.UTC(1975, 3),
                    onXAxis: true,
                }, {
                    from: Date.UTC(1980, 1),
                    to: Date.UTC(1980, 7),
                    onXAxis: true,
                }, {
                    from: Date.UTC(1981, 7),
                    to: Date.UTC(1982, 11),
                    onXAxis: true,
                }, {
                    from: Date.UTC(1990, 6),
                    to: Date.UTC(1991, 4),
                    onXAxis: true,
                }, {
                    from: Date.UTC(2007, 11),
                    to: Date.UTC(2009, 5),
                    onXAxis: true,
                }, {
                    from: Date.UTC(2001, 2),
                    to: Date.UTC(2001, 10),
                    onXAxis: true,
                }]
            });

            this.chart = Highcharts.stockChart(this.$el.find('.' + ns + '__chart')[0], {

                colors: colors,

                chart: {
                    //marginLeft: 0,
                    marginRight: 0,
                    events: {
                        afterPrint: $.proxy(this.onResize, this)
                    }
                },

                title: {
                    enabled: false
                },

                credits: {
                    enabled: false
                },

                navigator: {
                    maskFill: 'rgba(245, 130, 32, 1)',
                    series: {
                        color: '#f58220',
                        fillOpacity: '0.15'
                    }
                },

                navigation: {
                    buttonOptions: false
                },

                exporting: {
                    // sourceWidth: shareDimensions.facebook[0]* 1,
                    //sourceHeight: shareDimensions.facebook[1]* 1,
                    buttons: {
                        contextButton: {
                            enabled: false
                        }
                    },
                    chartOptions: {
                        rangeSelector: {
                            enabled: false
                        },
                        navigator: {
                            enabled: false
                        },
                        scrollbar: {
                            enabled: false
                        },
                        legend: {
                            enabled: false
                        },
                        title: {
                            x: 200,
                            y: 20,
                            useHTML: true,
                            text: 'Primary Mortgage Market SurveyÂ®',
                            style: {
                                fontSize: '16px'
                            },
                            align: 'left'
                        },

                        subtitle: {
                            text: 'U.S. weekly average mortgage rates as of LAST_UPDATED',
                            x: 200,
                            y: 39.5,
                            align: 'left',
                            useHTML: true,
                            style: {
                                fontSize: '13px'
                            }
                        },

                        chart: {
                            marginRight: 65,
                            marginTop: 60,
                            events: {
                                render: $.proxy(function (e) {
                                    this.setLineWidth(e);
                                    this.onRender(e);
                                }, this)
                            },
                            animation: {
                                complete: $.proxy(this.onRender, this)
                            }
                        }
                    }
                    //,
                    //formAttributes : {
                    //  width: shareDimensions.facebook[0],
                    //height: shareDimensions.facebook[1]
                    //}
                },

                rangeSelector: {
                    enabled: false,
                    inputEnabled: false,
                    inputPosition: {
                        align: 'right'
                    },
                    buttons: {
                        enabled: false
                    }
                },

                legend: {
                    enabled: true
                },

                xAxis: {
                    events: {
                        setExtremes: $.proxy(this.onSetExtremes, this),
                        afterSetExtremes: $.proxy(function (e) {
                            this.setLineWidth(e);
                            this.onSetExtremes(e);
                        }, this)
                    },
                    splotBands: [{
                        from: Date.UTC(1973, 11),
                        to: Date.UTC(1975, 3),
                        color: 'rgba(0,0,0,.1)',
                        label: false
                    }, {
                        from: Date.UTC(1980, 1),
                        to: Date.UTC(1980, 7),
                        color: 'rgba(0,0,0,.1)',
                        label: false
                    }, {
                        from: Date.UTC(1981, 7),
                        to: Date.UTC(1982, 11),
                        color: 'rgba(0,0,0,.1)',
                        label: false
                    }, {
                        from: Date.UTC(1990, 6),
                        to: Date.UTC(1991, 4),
                        color: 'rgba(0,0,0,.1)',
                        label: false
                    }, {
                        from: Date.UTC(2007, 11),
                        to: Date.UTC(2009, 5),
                        color: 'rgba(0,0,0,.1)',
                        label: false
                    }, {
                        from: Date.UTC(2001, 2),
                        to: Date.UTC(2001, 10),
                        color: 'rgba(0,0,0,.1)',
                        label: false
                    }],
                },

                yAxis: {
                    labels: {
                        format: '{value:.2f}%'
                    },
                    lineWidth: 1,
                    opposite: false,
                    plotLines: [{
                        value: 0,
                        width: 2,
                        color: 'silver'
                    }],
                    minTickInterval: 0.25
                },

                plotOptions: {
                    series: {
                        turboThreshold: this.turboThreshold,
                        showInNavigator: false,
                        lineWidth: 2,
                        dataGrouping: {
                            enabled: false
                        },
                        dataLabels: {
                            allowOverlap: true
                        }
                    }
                },

                tooltip: {
                    valueDecimals: 2,
                    backgroundColor: '#fff',
                    shared: true,
                    useHTML: true,
                    xDateFormat: 'Week ending %A, %b %e, %Y',
                    headerFormat: '<div style="font-family: Roboto; font-size: 13px; font-weight: bold; margin-bottom: 0.25em; display: block; color: #464645;">{point.key}</div><table style="font-family: Roboto; font-size: 1.1em; font-weight: 500;">',
                    pointFormat: '<tr><th><span style="color:{series.color}; font-weight: 500;">{series.name}</span>:</th><td>{point.y}%</td></tr>',
                    footerFormat: '</table>'
                },

                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 460
                        },
                        chartOptions: {
                            rangeSelector: {
                                inputEnabled: false
                            }
                        }
                    }]
                },

                series: this.series
            });

            // get the styles...
            //var stylesheet = $('link[href*="mortgage-charts.css"]').attr('href');
            //var styles = '';
            //if( stylesheet ){
            //    $.get( stylesheet ).done(function( resp ){
            //      styles = resp.replace(/\.mortgage-rate-widget\s+\.highcharts/gi, '.highcharts' );
            //      styles = styles.replace( /\.mortgage-rate-widget.*?\{.*?\}/gim, '' );
            //  });
            //}

            // var old = this.chart.getSVG;

            // var chart = this.chart;
            //var lastUpdate = this.lastUpdate;

            /*chart.getSVG = function(){
                var svg = old.apply( this, arguments );
                var $svg = $(svg);
                var $style = $('<style type="text/css" />').html( styles );
    */

            // change the viewbox and size of svg
            /*   $style.prependTo( $svg );
    
               var img = document.createElementNS('http://www.w3.org/2000/svg','image');
               img.setAttributeNS(null, 'height', 40 );
               img.setAttributeNS(null, 'width', 173 );
               img.setAttributeNS('http://www.w3.org/1999/xlink','href',DATA_URI_LOGO);
               img.setAttributeNS(null, 'x', 15 );
               img.setAttributeNS(null, 'y', 10 );
    
               $svg.append( img );
    
               var rendered = $svg[0].outerHTML;
               rendered = rendered.replace(/Â®/g, '<tspan style="font-size: 10px;" baseline-shift = "super">Â®</tspan>');
               rendered = rendered.replace(/LAST_UPDATED/, ' '+moment(lastUpdate).format('MM/DD/YYYY') );
    
               return rendered;*/

            //};

        },

        createRangePicker: function () {

            var $ct = $('<div class="' + ns + '__range-container" />').appendTo(this.$chartHeading);
            this.$rangeButtonsCt = $('<div class="' + ns + '__range-buttons-container" />');
            this.$rangeButtonsCt.appendTo($ct);

            this.$rangeButtonsCt.append('<span class="' + ns + '__label">Zoom</span>');
            this.$rangeButtons = $('<div class="' + ns + '__range-buttons" />').appendTo(this.$rangeButtonsCt);
            var $btns = this.$rangeButtons;
            var self = this;
            $.each(ranges, function (i, year) {
                var label = year == 'A' ? 'All' : year + 'Y';
                var $btn = $('<button class="' + ns + '__range-button" data-years="' + year + '">' + label + '</button>');
                $btns.append($btn);
                $btn.on('click', function (e) {
                    self.setExtremes($(this).data('years'), true);
                });
            });

            // add the download button
            /* $ct.append([
                 '<div class="'+ns+'__buttons">',
                     '<a href="#" class="'+ns+'__button '+ns+'__button--download" data-chart-action="download">',
                         'Download Chart Image',
                     '</a>',
                     '<a href="#" class="'+ns+'__button '+ns+'__button--print" data-chart-action="print">',
                         'Print Chart Image',
                     '</a>',
                     
                     '<a href="#" class="'+ns+'__button '+ns+'__button--facebook" data-chart-action="facebook">',
                         'Download Chart Image',
                     '</a>',
                     '<a href="#" class="'+ns+'__button '+ns+'__button--twitter" data-chart-action="twitter">',
                         'Download Chart Image',
                     '</a>',
                    
                 '</div>' 
             ].join(''));*/

            this.$range = $('<span class="' + ns + '__range"></span>');
            this.$range.appendTo($ct);
            this.$range.dateRangePicker({
                format: 'MM/DD/YYYY',
                separator: ' - ',
                monthSelect: true,
                yearSelect: [1971, moment().get('year')],
                getValue: function () {
                    return $(this).text();
                },
                setValue: function (s) {
                    this.innerHTML = s;
                }
            }).on('datepicker-change', $.proxy(function (e, o) {
                this.setRange(o.date1, o.date2);
            }, this));

            // add buttons
            this.setExtremes(1);
        },

        setRange: function (d1, d2) {
            this.settingRange = true;
            this.chart.xAxis[0].setExtremes(d1.getTime(), d2.getTime());
        },

        setExtremes: function (v, animate) {
            var last = this.series[0].data[this.series[0].data.length - 1].x;
            var start;
            if (v === 'A') {
                start = this.series[0].data[0].x
            }
            else {
                start = moment(last, 'x').subtract(v, 'year').valueOf();
            }
            this.chart.xAxis[0].setExtremes(start, last, 1, animate);
        },

        onRender: function (e) {
            var last = null;
            var series = !!e && e.target && e.target.series ? e.target.series : this.chart.series;
            var labels = [];
            if (series) $.each(series, function (i, s) {

                if (!s.dataLabelsGroup || !s.dataLabelsGroup.element) {
                    return;
                }
                // lets get in there and add the title below the label
                var el = s.dataLabelsGroup.element;

                var $t = $(el).find('text');
                var $g = $(el).find('>g');

                if (!$t.length) {
                    return;
                }

                if (!$(el).find('[class="fm-series-label"]').length) {

                    var oldBBox = el.getBBox();

                    // create a new tspan
                    var tspan = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
                    tspan.textContent = s.name;
                    tspan.setAttributeNS(null, 'x', $t[0].getAttributeNS(null, 'x'));
                    //tspan.setAttributeNS( null, 'y', Number( $t[0].getAttributeNS( null, 'y' ) ) + $t[0].getBBox().height - 4 );
                    // Hard because the values for the BBox vary per browser
                    tspan.setAttributeNS(null, 'y', 34);
                    tspan.setAttributeNS(null, 'class', 'fm-series-label');
                    $(tspan).css({
                        "font-size": '11px'
                    });
                    $t.append(tspan);
                }

                var BBox = el.getBBox();

                var transform = $g[0].getAttributeNS(null, 'transform');
                var y = s.data[s.data.length - 1].plotY - BBox.height / 2 - 10;

                if (y <= last) {
                    y = last;
                }


                $g[0].setAttributeNS(null, 'transform', transform.replace(/\((\-?\d+)([\,\s]+)(\-?[\.\d]+)\)/, '($1$2' + (y || 0) + ')'));
                labels.push({ $g: $g, BBox: BBox, y: y });

                last = y + BBox.height + 10;

                // what if this extends beyone the bottom of the chart...

            });

            var bottom = e.target.plotBox.height;

            var lastLabel = null;

            var offset = last - bottom;

            if (last > bottom) {

                $.each(labels.reverse(), function (i, label) {
                    var y = label.y - offset;
                    var transform = label.$g[0].getAttributeNS(null, 'transform');
                    var replaced = transform.replace(/\((\-?\d+)([\,\s]+)(\-?[\.\d]+)\)/, '($1$2' + y + ')');

                    label.$g[0].setAttributeNS(null, 'transform', replaced);

                    // check to see if there is another one after this...
                    if (labels[i + 1]) {
                        if (labels[i + 1].BBox.height + 10 + labels[i + 1].y > y) {
                            offset = (labels[i + 1].BBox.height + 10 + labels[i + 1].y) - y;
                        }
                        else {
                            return false;
                        }
                    }
                });
            }

            var $group = this.$el.find('[class="highcharts-input-group"]');
            if ($group.length) {

            }
        },

        onSetExtremes: function () {
            if (!this.chart || !this.chart.xAxis) return;
            //if( this.settingRange ) return;
            var extremes = this.chart.xAxis[0].getExtremes();
            var min = new Date(), max = new Date();
            min.setTime(extremes.min);
            max.setTime(extremes.max);
            this.$range.data('dateRangePicker')
                .setDateRange(min, max, true);

            // check for button
            var diff = moment(max).diff(min);

            var years = Math.round(diff / (1000 * 60 * 60 * 24 * 365));

            var series = this.chart.series[0];

            if (diff == moment(series.data[series.data.length - 1].x).diff(series.data[0].x)) {
                years = 'A';
            }

            this.$rangeButtons.find('button').removeClass('active');
            this.$rangeButtons.find('button[data-years="' + years + '"]').addClass('active');
        },

        setLineWidth: function (e) {
            if (e && e.target && e.target.chart) {
                var chart = e.target.chart;

                var extremes = chart.xAxis[0].getExtremes();
                var year = 1000 * 60 * 60 * 24 * 365;
                var diff = extremes.max - extremes.min;
                var group = $(chart.container).find('.highcharts-series-group')[0];
                var className = group.getAttribute('class');
                className = className.replace(/(^|\s)line-width[^\s]+/, '');
                group.setAttribute('class', className);
                var lineWidth = 4;
                if (diff > 20 * year) {
                    group.setAttribute('class', className + " line-width-1");
                }
                else if (diff > 10 * year) {
                    group.setAttribute('class', className + " line-width-2");
                }
                else if (diff > 3 * year) {
                    group.setAttribute('class', className + " line-width-3");
                }
            }
        },
        onResize: function () {
            var size, w = this.$el.width();
            switch (true) {

                case w > 600:
                    size = 'large';
                    break;

                case w > 550:
                    size = 'medium';
                    break;

                case w > 360:
                    size = 'small';
                    break;

                default:
                    size = 'xsmall';
                    break;


            }
            this.$el.attr('data-size', size);
        }

    });
    MortgageChart.instances = [];
    MortgageChart.instances.push(new MortgageChart($('.' + ns)[0]));
}


//$(function () {
//    MortgageChart.instances.push(new MortgageChart($('.' + ns)[0]));
//});

